
<div mat-dialog-title class="segment-title" style="margin-top: 1rem;">Confirm</div>
<div mat-dialog-content class="segment-content mb-4 container">
   <p> {{confirmMessage}}</p>

    <div class="row segment-action-btns {{ApplicantLoanComponent.currentChannel?.channelName}}" mat-dialog-actions style="padding: 0 !important;">
      <button mat-raised-button style="margin-bottom: 10px;" class="btn btn-custom btn-continue btn-block col" id="confirm_button" (click)="dialogRef.close(true)">Confirm</button>
      <span class="col-md-1"></span>
      <button mat-stroked-button class="btn btn-custom btn-continue-primary col"  (click)="dialogRef.close(false)">Cancel</button>
    </div>
</div>
